module.exports = __webpack_public_path__ + "img/logo.8600f805.png";